import React from 'react'
import styled from 'styled-components'

import { Trend } from '@root/entities/trend'

import { METRICS_COLOR_MAP, type MetricsTheme } from './constants'

type Props = {
  startLabel: string
  endLabel: string
  startValue: React.ReactNode
  endValue: React.ReactNode
  startPercents: number
  metricsTheme: MetricsTheme
}

export const TradingPairSummaryRow = ({
  startValue,
  endLabel,
  startLabel,
  endValue,
  startPercents,
  metricsTheme,
}: Props) => (
  <Root>
    <TitleUppercase>
      <div>{startLabel}</div>
      <div>{endLabel}</div>
    </TitleUppercase>
    <Value color={METRICS_COLOR_MAP[metricsTheme]['white']}>
      <div>{startValue}</div>
      <div>{endValue}</div>
    </Value>
    <Ratio>
      <RatioBuy
        $percents={startPercents}
        $color={METRICS_COLOR_MAP[metricsTheme][Trend.Up]}
      />
      <RatioSell
        $percents={100 - startPercents}
        $color={METRICS_COLOR_MAP[metricsTheme][Trend.Down]}
      />
    </Ratio>
  </Root>
)

const Root = styled.div`
  height: 50px;
`

const Title = styled.div`
  color: var(--text-9);

  font-size: 10px;
  font-weight: 600;
  line-height: 12px;

  display: flex;
  justify-content: space-between;
`

const TitleUppercase = styled(Title)`
  text-transform: uppercase;
`

const Value = styled.div<{ color: string }>`
  color: ${({ color }) => color};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;

  display: flex;
  justify-content: space-between;
`

const Ratio = styled.div`
  display: flex;

  border-radius: 4px;
  height: 10px;
  gap: 2px;
  padding: 2px 1px;
`

const RatioBuy = styled.span<{ $percents: number; $color: string }>`
  height: 6px;
  border-radius: 4px;
  background: ${({ $color }) => $color};
  flex: ${({ $percents }) => $percents}%;
`

const RatioSell = styled(RatioBuy)<{ $color: string }>`
  background: ${({ $color }) => $color};
`
